import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackScreenView } from '../lib/analytics';

export default function ScreenTracker() {
  const location = useLocation();
  useEffect(() => {
    trackScreenView(location.pathname);
  }, [location.pathname]);
  return null;
}
